var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduce-container"},[(_vm.data === null)?_c('placeholder',[_vm._v("\n        未填写参赛介绍\n    ")]):_c('plain-block',{staticClass:"plain-block"},[_vm._v("\n        "+_vm._s(_vm.data)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }